// Analytics containers
export const ANALYTICS_EVENT_CONTAINER_PRICING_TAB = 'appListingPricingTab';
export const ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR = 'siteSelector';
export const ANALYTICS_EVENT_CONTAINER_MPAC_SUPPORT_TAB = 'MPACSupportTab';
export const ANALYTICS_EVENT_CONTAINER_EMCEE_SUPPORT_TAB = 'EMCEESupportTab';

// Analytics subject ids
export const ANALYTICS_SUBJECT_ID_ADDITIONAL_PRICING_EXAMPLE = 'additionalPricingExample';
export const ANALYTICS_SUBJECT_ID_CONTACT_ADMIN = 'contactAdmin';
export const ANALYTICS_SUBJECT_ID_INSTALL_APP = 'installApp';
export const ANALYTICS_SUBJECT_ID_USER_COUNT = 'inputUserCount';
export const ANALYTICS_SUBJECT_ID_REVIEW_COMPLIANCE_LINK = 'reviewComplianceLink';
export const ANALYTICS_SUBJECT_ID_REVIEW_COMPLIANCE_MODAL_CLOSE_BUTTON = 'reviewComplianceModalCloseButton';
export const ANALYTICS_SUBJECT_ID_REVIEW_PROFILE_CLICKABLE_LINK = 'userProfilePage';
export const ANALYTICS_SUBJECT_ID_REVIEW_COMPLIANCE_MODAL = 'reviewComplianceModal';
export const ANALYTICS_SUBJECT_ID_SUPPORT_TAB_PRICING_LINK = 'supportTabPricingLink';

// Overview tab
export const ANALYTICS_OVERVIEW_ARTIFACT_RESOURCE_LINK = 'artifactResourceLink';
export const ANALYTICS_OVERVIEW_DESCRIPTOR_RESOURCE_LINK = 'descriptorResourceLink';
export const ANALYTICS_OVERVIEW_DOCUMENTATION_RESOURCE_LINK = 'documentationResourceLink';
export const ANALYTICS_OVERVIEW_EULA_RESOURCE_LINK = 'eulaResourceLink';

//Review tab
export const ANALYTICS_REVIEW_WRITE_REVIEW_BUTTON = 'writeReviewButton';
export const ANALYTICS_REVIEW_READ_MORE_BUTTON = 'readMoreReviewButton';
export const ANALYTICS_REVIEW_SORT_BUTTON = 'sortReviewButton';

// Pricing Tab
export const ANALYTICS_CONTACT_SALES_LINK = 'contactSales';

// Analytics Sources
export const ANALYTICS_EVENT_SOURCE_CONTACT_PARTNER_CLOUD = 'cloud';
export const ANALYTICS_EVENT_SOURCE_CONTACT_PARTNER_DATA_CENTER = 'dataCenter';